import { GenericTableRawData } from '../components/Deck/Charts/types';

interface FormatDataArgs {
  rawData: GenericTableRawData;
  parsingExceptions?: string[];
}

function formatKeyWithoutSpaces(key: string): string {
  return key.replaceAll(' ', '');
}

export function formatData <T>({ rawData, parsingExceptions }: FormatDataArgs): T {
  const cleanedData = { ...rawData, cols: rawData.cols.slice(1) };
  const formattedData: Record<string, Record<string, number>> = {};
  for (let i = 0; i < cleanedData.rows.length; i += 1) {
    const mainKey = cleanedData.rows[i][0].split(' ')[0];
    const values = cleanedData.rows[i].slice(1);
    for (let j = 0; j < cleanedData.cols.length; j += 1) {
      const key = formatKeyWithoutSpaces(cleanedData.cols[j] as string);
      if (key) {
        formattedData[mainKey] = formattedData[mainKey] || {};
        const valueNum = Number(values[j]);
        let formattedValue: number;
        if (parsingExceptions && parsingExceptions.includes(key)) {
          formattedValue = +(valueNum / 100).toPrecision(2);
        } else {
          formattedValue = +(valueNum).toPrecision(2);
        }
        formattedData[mainKey][key] = formattedValue;
      }
    }
  }
  // @ts-expect-error: Intentional cast, T is expected to match the formattedData structure
  return formattedData as T;
}
